// extracted by mini-css-extract-plugin
module.exports = {"ModalWindow":"src-components-modals-ModalDialogWindow-modefiedUIKitComponent-styles__ModalWindow--1_GuY"};